import React from "react";

const GroupArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.25"
      height="15"
      viewBox="0 0 19.25 15"
    >
      <g
        id="Group_1398"
        data-name="Group 1398"
        transform="translate(-166.125 -389)"
      >
        <line
          id="Line_16"
          data-name="Line 16"
          y2="11.786"
          transform="translate(166.625 389)"
          fill="none"
          stroke="#000"
          strokeWidth="1"
        />
        <line
          id="Line_17"
          data-name="Line 17"
          x2="13.393"
          transform="translate(166.625 400.786)"
          fill="none"
          stroke="#000"
          strokeWidth="1"
        />
        <g
          id="Polygon_3"
          data-name="Polygon 3"
          transform="translate(185.375 397.571) rotate(90)"
          fill="#fff"
        >
          <path
            d="M 5.586256504058838 5.392858505249023 L 0.8422697782516479 5.392858505249023 L 3.214263200759888 1.044167041778564 L 5.586256504058838 5.392858505249023 Z"
            stroke="none"
          />
          <path
            d="M 3.214263200759888 2.088345527648926 L 1.684541702270508 4.892858505249023 L 4.743984699249268 4.892858505249023 L 3.214263200759888 2.088345527648926 M 3.214263200759888 -1.430511474609375e-06 L 6.428523063659668 5.892858505249023 L 3.337860107421875e-06 5.892858505249023 L 3.214263200759888 -1.430511474609375e-06 Z"
            stroke="none"
            fill="#000"
          />
        </g>
      </g>
    </svg>
  );
};

export default GroupArrowIcon;
